import { Box, Image } from '@bfa/common-ui';
import { CmsImage } from '@bfa/nextjs-common/utils';
import React from 'react';

import { extractAttributesFromCmsImages } from '../../../../utils/extractAttributesFromCmsImages';

const heroImage = ({
  landingHeroImg,
}: {
  landingHeroImg: (CmsImage | undefined | null)[];
}) => {
  const extractedCmsImages = extractAttributesFromCmsImages(landingHeroImg);

  if (!extractedCmsImages) return null;

  return (
    <Box>
      <Image {...extractedCmsImages} skipImageOptimization />
    </Box>
  );
};

export default heroImage;
